import { createAsyncThunk } from '@reduxjs/toolkit';

import MAIL_API from './mail.api';

export const mailConfigAction = createAsyncThunk<
any, any
>('mail.mailConfig', async ({ _ }, { rejectWithValue }) => {
  try {
    const res = await MAIL_API.mailConfigAPI();
    return res;
  } catch (err: any) {
    return rejectWithValue(err);
  }
});

export const settingMailConfigAction = createAsyncThunk<
any,
Mail.SettingMailConfigPayload
>('mail.settingMailConfig', async ({ data }, { rejectWithValue }) => {
  try {
    const res = await MAIL_API.settingMailConfigAPI(data);
    return res;
  } catch (err: any) {
    return rejectWithValue(err);
  }
});
